<template>
    <div class="block-bid-member-favorite">
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-current-price">
                    <div class="current-price border-color-red">
                        <div class="top">
                            <div v-if="isOnlineOrPreBid || isStreamingLive" class="text-price-now font-weight-bold">
                                現在価格
                            </div>
                            <div v-else-if="isEndPreBid || isEndLive || isLive" class="text-price-now font-weight-bold">
                                最高事前入札価格
                            </div>
                            <div class="price color-red">
                                <span class="number">¥</span>
                                <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                            </div>
                            <div class="tax-fee">
                                <span class="text">消費税手数料込</span>
                                <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-noti">
                    <div class="text-updated" v-if="message">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>{{ message }}</span>
                    </div>
                </div>
                <div class="block-enter-bid" v-if="!isStreamingLive && !isLive">
                    <div class="left">あなたの入札価格</div>
                </div>
                <div class="block-sent-bid">
                    <div class="block-top" :class="(!isStreamingLive && !isLive) ? '' : 'd-none'">
                        <div v-if="isOnlineOrPreBid" class="block-input">
                            <input type="text" id="input-bid" class="input-bid"
                                   v-model="pricePlaced" @input="validateNumberInput()">
                        </div>
                        <div v-else-if="isEndPreBid || isEndLive" class="block-input">
                            <input disabled type="text" id="input-bid" class="input-bid cursor-not-allowed"
                                   v-model="pricePlaced">
                        </div>
                    </div>
                    <div :id="'errors-price-' + product.id" class="error d-none">現在価格より大きい価格を入力してください。</div>
                    <div class="block-center">
                    </div>
                    <div class="block-bottom">
                        <button v-if="isOnlineOrPreBid" class="btn-send-price btn-large" @click.prevent="handleSavePriceBid">入札する</button>
                        <button v-else-if="isEndPreBid" disabled class="btn-large cursor-not-allowed btn-large-disable">入札終了</button>
                        <button v-else-if="isStreamingLive" class="btn-large btn-live mt-2" @click.prevent="redirectLive">LIVE画面に移動する</button>
                        <button disabled v-else-if="isLive" class="btn-large btn-live mt-2">LIVE画面に移動する</button>
                        <button v-else-if="isEndLive" disabled class="btn-large cursor-not-allowed btn-large-disable">終了</button>

                        <!-- Modal -->
                        <div class="modal fade" :id="'priceBidProductMemberModal-' + this.product.id" tabindex="-1" aria-labelledby="exampleModalLabel"
                             aria-hidden="true" data-backdrop="static">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header border-bottom-0">
                                        <h3 class="modal-title font-weight-bold text-right" style="width: 59%">入札確認</h3>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <span>入札価格 :</span>
                                        <span class="color-red">¥{{ formatPrice(pricePlaced) }}</span>
                                    </div>
                                    <div class="text-center mt-1">
                                        <span>手数料含む</span>
                                        <span>(¥{{
                                                handlePriceTaxAndServiceFee(pricePlaced)
                                            }})</span>
                                    </div>
                                    <div class="text-center mt-1 mb-4">
                                        <span>この金額で入札する</span>
                                    </div>
                                    <div class="modal-footer border-top-0 justify-content-center">
                                        <button @click="updateBidPrice()" class="btn btn-submit-modal-bid-price-product">はい</button>
                                        <button type="button" class="btn btn-cancel-modal-bid-price-product" data-dismiss="modal">いいえ</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {COMMON} from "./../../common";
import CONSTANTS from "../constants";

export default {
    mounted() {

    },
    async created() {
        this.serviceFee = this.taxConfig.service_fee;
        this.tax = this.taxConfig.tax;
        this.pricePlaced = this.myBidTop ? this.formatPrice(this.myBidTop.amount) : 0;

        this.checkPriceMember();
        this.checkEnableDisableInputAndButton();

        Echo.channel('bid.pre_bid.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.pre_bid.sent', (e) => {
                this.bidTop = e.bidTop;
                this.message = 'あなたより他のお客様が高値で入札しました。';
            });
        Echo.channel('bid.online_bid.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.online_bid.sent', (e) => {
                this.bidTop = e.bidTop;
                this.message = 'あなたより他のお客様が高値で入札しました。';
            });
    },
    props: [
        'product',
        'auction',
        'member',
        'bidTop',
        'myBidTop',
        'taxConfig'
    ],
    data: function () {
        return {
            serviceFee: 0,
            tax: 0,
            pricePlaced: 0,
            interval: null,
            message: null,
            isOnlineOrPreBid: false,
            isEndPreBid: false,
            isStreamingLive: false,
            isLive: false,
            isEndLive: false
        }
    },
    methods: {
        async updateBidPrice() {
            await axios.post('/bid/update-bid-price', {
                auctionId: this.auction.id,
                productId: this.product.id,
                amount: this.pricePlaced,
            })
                .then(response => {
                    if (response.data.myBidTop) {
                        this.myBidTop = response.data.myBidTop;
                    }
                })
                .catch(error => {
                    if(error.response.status === 422) {
                        alert('オークション期間は終了しました。');
                        window.location.reload();
                    }
                })
            this.closeModal();
        },

        clearValue() {
            return document.getElementsByClassName('input-bid')[0].value = '';
        },

        formatPrice(price) {
            return COMMON.handleFormatPrice(price);
        },

        formatDate(time) {
            return COMMON.handleFormatDate(time);
        },

        validateNumberInput() {
            this.pricePlaced = COMMON.maximumCharacterLimitPrice(event.target.value.replace(/[^0-9]/g, ''));
        },

        handlePriceTaxAndServiceFee(pricePresent) {
            let price = COMMON.handlePriceTaxAndServiceFee(pricePresent, this.serviceFee, this.tax);

            return this.formatPrice(price);
        },

        partIntPricePlaced () {
            if (this.pricePlaced && typeof this.pricePlaced === 'string') {
                this.pricePlaced = parseInt(this.pricePlaced.replace(/[^0-9]/g, ''))
            }
        },

        handleSavePriceBid() {
            this.partIntPricePlaced();
            if (this.bidTop) {
                if (this.bidTop.amount < this.pricePlaced) {
                    this.openModal();
                } else {
                    document.getElementById('errors-price-' + this.product.id).classList.remove('d-none');
                    setTimeout( () => {
                        document.getElementById('errors-price-' + this.product.id).classList.add('d-none');
                    }, 5000)
                }
            } else {
                if (this.product.price_start_bid < this.pricePlaced) {
                    this.openModal();
                } else {
                    document.getElementById('errors-price-' + this.product.id).classList.remove('d-none');
                    setTimeout( () => {
                        document.getElementById('errors-price-' + this.product.id).classList.add('d-none');
                    }, 5000)
                }
            }
        },

        redirectLive() {
            window.location.href = `/auction/live`;
        },

        checkPriceMember() {
            if (this.myBidTop && this.myBidTop.amount < this.product.price_lowest_winning) {
                this.message = '最低落札価格に達していません。';
            }
            if (this.bidTop && this.bidTop.member_id != this.member.id) {
                this.message = 'あなたより他のお客様が高値で入札しました。';
            }
            if (this.bidTop && this.bidTop.member_id == this.member.id) {
                this.message = 'あなたが現在の最高額入札者です。';
            }

            return null;
        },

        checkEnableDisableInputAndButton() {
            if ((this.auction.classification == CONSTANTS.AUCTION_CLASSIFICATION_ONLINE && this.auction.state == CONSTANTS.AUCTION_STATE_STARTED) ||
                (this.auction.is_prebid == CONSTANTS.AUCTION_IS_PREBID && this.auction.state == CONSTANTS.AUCTION_STATE_PREBID))
            {
                this.isOnlineOrPreBid = true;
            } else if (this.auction.state == CONSTANTS.AUCTION_STATE_PREBID_END || this.auction.state == CONSTANTS.AUCTION_STATE_END) {
                this.isEndPreBid = true;
            } else if (this.auction.classification !== CONSTANTS.AUCTION_CLASSIFICATION_ONLINE && this.auction.state == CONSTANTS.AUCTION_STATE_STARTED) {
                this.isStreamingLive = true;
                this.message = '現在の入札価格が更新されています';
            } else if (this.auction.state == CONSTANTS.AUCTION_STATE_END) {
                this.isEndLive = true;
            } else if (this.auction.classification !== CONSTANTS.AUCTION_CLASSIFICATION_ONLINE) {
                this.isLive = true;
            }
        },

        openModal() {
            $('#priceBidProductMemberModal-' + this.product.id).modal('show');
        },

        closeModal() {
            $('#priceBidProductMemberModal-' + this.product.id).modal('hide');
        },

    },
    computed: {

    },
}
</script>
